module.exports = __webpack_public_path__ + "static/media/16UNODC28.c208402e.jpg";